export default __webpack_public_path__ + "img/8e63ac76cae0df673b27ea4bf8156e66.svg";